<template>
  <div v-if="tpOptions.showAside" class="le-tp-aside">
    <el-tabs :tab-position="tabPosition" class="le-tp-tabs-aside" @tab-click="handleTabChangeEvent">
      <el-tab-pane v-for="module in moduleArray" v-if="module.showStatus === 1" :key="module.id || module.idField">
        <template slot="label">
          <div class="le-tab-a">
            <i v-if="module.iconType === 0" :class="module.iconContent" />
            <img v-else :src="module.iconUrl" :alt="module.elementName" />
            <span class="le-tab-txt">{{ module.elementName }}</span>
          </div>
        </template>

        <div class="le-tab-con">
          <div class="le-tp-search-con">
            <div class="le-col le-tp-input-col">
              <el-input v-model="searchContext" placeholder="请输入内容" prefix-icon="el-icon-search" :clearable="true" @input="handleInputEvent($event, module.elementIdentity)" />
            </div>

            <div v-if="computeUploadBtnShowStatus(module.elementIdentity)" class="le-col le-tp-btn-col">
              <el-tooltip effect="dark" placement="bottom" content="上传素材">
                <div class="le-tp-btn-upload">
                  <i class="tp-icon el-icon-upload" />
                </div>
              </el-tooltip>
            </div>
          </div>

          <el-collapse v-if="module.children.length > 0" v-model="activeNames" class="le-tp-collapse">
            <el-collapse-item v-for="(type, index) in module.children" v-if="type.showStatus === 1" :key="type.id" class="le-tp-collapse-item" :title="type.elementName" :name="index + 1">
              <div
                v-for="ele in type.children"
                v-if="ele.showStatus === 1"
                :key="ele.id || ele.idField"
                class="le-tp-ele-group le-drag-handle"
                draggable="true"
                @click="handleClickEvent(ele)"
                @dragstart="handleDragStartEvent($event, ele, module.elementIdentity)">

                <div class="le-tp-ele-con">
                  <i v-if="ele.iconType === 0" :class="ele.iconContent" />
                  <img v-else :src="ele.iconUrl" :alt="ele.elementName" />
                  <span class="tp-ele-txt">{{ ele.elementName }}</span>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>

          <template v-if="!dataShowStatus">
            <el-empty description="暂无数据" />
          </template>
        </div>
      </el-tab-pane>

      <el-tab-pane name="layer">
        <template slot="label">
          <div class="le-tab-a">
            <i class="le-tab-icon lt tp-icon-tu-ceng-fill" />
            <span class="le-tab-txt">元素图层</span>
          </div>
        </template>

        <div class="le-layer-tab-con">
          <draggable v-if="shapeArray.length > 0" ref="leDraggable" tag="div" :list="shapeArray" class="le-tp-draggable" handle=".le-drag-handle" @end="handleDragEndEvent">
            <div v-for="item in shapeArray" :key="item.id" class="le-layer-item" :class="{'is-active' : handleLayerComputeIsActive(item.id)}" @click="handleLayerShapeClickEvent(item.id)">
              <div class="le-layer-row">
                <div class="le-layer-col le-layer-tool le-drag-handle">
                  <div class="le-layer-drag-handle">
                    <svg data-icon="drag-handle-vertical" width="16" height="16" viewBox="0 0 16 16">
                      <path d="M6 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm4-6c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zM6 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm4 8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z" fill-rule="evenodd" />
                    </svg>
                  </div>
                  <div class="le-layer-type">
                    <span class="type">{{ item.type }}</span>
                  </div>
                  <div class="le-layer-name">
                    <el-input v-model="item.name" class="le-layer-input le-layer-name-input" placeholder="请输入内容" @change="handleLayerShapeChangeEvent($event, item.id)" />
                  </div>
                </div>

                <div class="le-layer-col le-layer-btn-group">
                  <el-tooltip class="item" effect="dark" content="显示/隐藏" placement="bottom">
                    <el-button class="le-layer-btn" :icon="handleShowClass(item.id)" @click="handleLayerShapeShowEvent(item.id)" />
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="锁定/解锁" placement="bottom">
                    <el-button class="le-layer-btn" :icon="handleLockClass(item.id)" @click="handleLayerShapeLockEvent(item.id)" />
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
                    <el-button class="le-layer-btn" icon="lt tp-icon-shan-chu" @click="handleLayerShapeDeleteEvent(item.id)" />
                  </el-tooltip>
                </div>
              </div>
            </div>
          </draggable>

          <div v-if="shapeArray.length === 0" class="le-tp-empty">
            <el-empty description="无图层数据" />
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import {childMixins, commonMixins} from '../../scripts/mixins';
import {listTpElementData} from '../../scripts/data';
import {identityConst} from '../../scripts/conf';

export default {
  name: 'LeTpAside',
  components: {
    draggable
  },
  mixins: [childMixins, commonMixins],
  data() {
    return {
      tabPosition: 'right',
      activeNames: [1],
      searchContext: '',
      moduleArray: [],
      dataShowStatus: true,
      shapeArray: [],
      selectedLayerShapeIds: {}
    };
  },
  computed: {
    layerShapeArray() {
      // 清空图层选中状态
      // this.selectedLayerShapeIds = {};
      // const childrenArray = this.getLayer()?.getChildren();
      // const shapeArray = [];
      // childrenArray?.forEach(child => {
      //   if (!excludeNodeArray.includes(child.name())) {
      //     shapeArray.push({id: child.id(), name: child.name(), type: handleComputeShapeCustomType(child.getClassName()), zIndex: child.getZIndex()});
      //   }
      // });
      // // 排序
      // sortDescArray(shapeArray, 'zIndex');
      // return shapeArray;
      return [];
    }
  },
  watch: {
    layerShapeArray: {
      handler(newValue) {
        this.shapeArray = newValue;
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.loadElementInfo();
  },
  methods: {
    loadElementInfo() {
      listTpElementData().then(resp => {
        this.moduleArray = resp?.data || [];
      });
    },
    handleClickEvent(ele) {
      this.$emit('click', ele);
    },
    handleTabChangeEvent(e) {
      this.activeNames = [1];
      this.searchContext = '';
      this.$bus.$emit('tp:aside:tabsChangeShowDialog');
    },
    handleInputEvent(searchContext, elementIdentity) {
      this.moduleArray.forEach(module => {
        if (module.elementIdentity === elementIdentity) {
          // 过滤筛选
          this.handleFilterElementItem(module.children, searchContext);
          // 是否有状态为显示的
          this.dataShowStatus = module.children.some(item => item.showStatus === 1);
        }
      });
    },
    handleFilterElementItem(array, searchContent) {
      // 过滤元素分类
      array?.forEach(item => {
        const includeStatus = item?.elementName?.includes(searchContent.trim());
        let showLen = 0;
        if (item.children && Array.isArray(item.children) && item.children.length > 0) {
          this.handleFilterElementItem(item.children, searchContent);
          showLen = item.children.filter(child => child?.showStatus === 1).length;
        }

        item.showStatus = (includeStatus || showLen > 0) ? 1 : 0;
      });
    },
    handleFilterTreeNode(arr, keyword) {
      // 过滤树节点，返回新数组，频繁改变数组
      const emptyArr = [];
      for (const item of arr) {
        if (item.elementName.includes(keyword)) {
          if (item.children && Array.isArray(item.children) && item.children.length > 0) {
            item.children = this.filterTree(item.children, keyword);
          }
          emptyArr.push(item);
        } else if (item.children && Array.isArray(item.children) && item.children.length > 0) {
          item.children = this.filterTree(item.children, keyword);
          if (item.children.length) {
            emptyArr.push(item);
          }
        }
      }
      return emptyArr;
    },
    computeUploadBtnShowStatus(elementIdentity) {
      const status = elementIdentity === identityConst.pictureMaterial || elementIdentity === identityConst.backgroundPicture;
      return elementIdentity ? status : false;
    },
    handleDragStartEvent(evt, ele, moduleIdentity) {
      // 拖动组件开始
      const data = {eleId: ele?.id || ele?.idField, moduleIdentity, elementIdentity: ele?.elementIdentity};
      evt.dataTransfer.setData('tp:element:ShapeAttribute', JSON.stringify(data));
    },
    handleDragEndEvent(evt) {
      // if (this.shapeArray.length <= evt.newIndex) {
      //   console.warn('图形图层位置异常，请检查数据');
      //   return;
      // }
      //
      // // 获取图形新位置上一个图形坐标，也就是当前背后图层坐标减一。重新赋值排序对象
      // let shapeIndex = getArrayMaxNumber(this.shapeArray, 'zIndex', true);
      // if (evt.newIndex > 0) {
      //   const beforeShape = getShapeById(this, this.shapeArray[evt.newIndex - 1]?.id);
      //   shapeIndex = sub(beforeShape?.getZIndex(), 1);
      // }
      //
      // this.shapeArray?.forEach((child, i) => {
      //   if (i >= evt.newIndex) {
      //     const shape = getShapeById(this, child.id);
      //     // 移动后的最新位置 4  1
      //     if (i === evt.newIndex && shape) {
      //       shape.setZIndex(shapeIndex);
      //     } else if (i > evt.newIndex && shape) {
      //       shapeIndex--;
      //       shape.setZIndex(shapeIndex);
      //     }
      //     this.getLayer().draw();
      //   }
      // });
      // this.getLayer().batchDraw();
    },
    handleShowClass(eleId) {
      // return getShapeShowStatusById(this, eleId) ? 'lt tp-icon-yin-fill' : 'lt tp-icon-xian-fill';
    },
    handleLockClass(eleId) {
      // return getShapeLockStatusById(this, eleId) ? 'lt tp-icon-suo-ding' : 'lt tp-icon-jie-suo';
    },
    handleLayerComputeIsActive(eleId) {
      // 处理选中背景色状态
      // return eleId ? (this.selectedLayerShapeIds[eleId] || getShapeSelectedStatusById(this, eleId)) : false;
    },
    handleLayerShapeClickEvent(eleId) {
      // 处理行选中状态
      const status = this.selectedLayerShapeIds[eleId];
      this.selectedLayerShapeIds = {};
      this.selectedLayerShapeIds[eleId] = status;
      this.$set(this.selectedLayerShapeIds, eleId, !this.selectedLayerShapeIds[eleId]);
      // handleSelectedShapeById(this, eleId);
    },
    handleLayerShapeChangeEvent(val, eleId) {
      // 图形名称变更时处理
      // const shape = getShapeById(this, eleId);
      // if (shape) {
      //   shape.name(val);
      //   this.getLayer().draw();
      // }
    },
    handleLayerShapeShowEvent(eleId) {
      // 显示/隐藏图形
      // showOrHideShapeById(this, eleId);
    },
    handleLayerShapeLockEvent(eleId) {
      // 锁定/取消锁定图形
      // lockOrUnlockShapeById(this, eleId);
    },
    handleLayerShapeDeleteEvent(eleId) {
      // 删除图形
      // deleteShapeById(this, eleId);
    }
  }
};
</script>

<style scoped>

</style>
